var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-5"},[_c('md-empty-state',{staticClass:"md-accent",attrs:{"md-rounded":"","md-icon":"priority_high","md-label":"Ooops","md-description":"Ha habido un problema en el registro.\n       Por favor, contacta con el administrador: (info@masmadrid.org)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }